// @flow
import { Component } from 'react';
import { type TrackingEvent } from './TrackingEventTypes.constants';
import { withTracking } from './withTracking';
import { type TrackEvent } from './TrackingProvider';

type Props = {
  children: any,
  eventName: TrackingEvent,
  track: TrackEvent,
};

class TrackOnMount extends Component<Props> {
  componentDidMount() {
    const {
      eventName,
      track,
    } = this.props;

    if (eventName && track) {
      track(eventName);
    }
  }

  render() {
    const {
      children,
    } = this.props;

    return children || null;
  }
}


export default withTracking(TrackOnMount);
